export default {
  path: '/nozzle_ins',
  name: 'nozzle_ins',
  component: () => import('../components/nozzlein/Layout'),
  redirect: { name: 'NozzleInList' },
  meta: {
    breadcrumb: 'profile.nozzle.nozzlesin',
  },
  children: [
    {
      name: 'NozzleInList',
      path: '',
      component: () => import('../views/nozzlein/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'NozzleInCreate',
      path: 'new',
      component: () => import('../views/nozzlein/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'NozzleInUpdate',
      path: ':id/edit',
      component: () => import('../views/nozzlein/Update'),
      meta: {
        breadcrumb: 'profile.nozzle.nozzlein',
      },
    },
    {
      name: 'NozzleInShow',
      path: ':id',
      component: () => import('../views/nozzlein/Show'),
      meta: {
        breadcrumb: 'profile.nozzle.nozzlein',
      },
    }
  ]
};
